import { useTranslation } from 'react-i18next';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';
import { ImportArguments, ImportFormData, ImportResponse } from './type';

const importMultiInvite = async (formData: ImportFormData) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/import-multi-invite`;
  return request({ url, method: RequestMethod.POST, body: formData });
};
export const useImportMultiInvite = ({ hideToast }: { hideToast?: boolean }) => {
  const { t } = useTranslation();
  const toast = useToast();

  return useGenericMutation(
    [QUERY_KEYS.importMultiInvite],
    async ({ importData }: ImportArguments): ImportResponse => importMultiInvite(importData),
    {
      onSuccess: hideToast
        ? () => {}
        : () => {
            toast.push({
              title: t('offers:importCsvSuccessNotificationTitle'),
              text: '',
              type: 'success',
            });
          },
    }
  );
};
